import { request } from '@/shares/request';
export const getExchangeConfig = {
  fetcher: () =>
    request(`/operation/v1/bwbexchange/getExchangeConfig`, {
      method: 'post',
    }),
  key: 'getExchangeConfig',
};

export const listExchangeOrder = {
  fetcher: ({ address, page, limit }: { address: string; page: number; limit: number }) =>
    request(`/operation/v1/bwbexchange/listExchangeOrder`, {
      method: 'post',
      data: {
        address,
        page,
        limit,
      },
    }),
  key: 'listExchangeOrder',
};
interface IExchangeOrderSend {
  chain: string;
  sig: string;
  from: string;
  to: string;
  contract: string;
  amount: number;
  toAddress: string;
  toChain: string;
  exchangeRate: number;
  bgbSendGas: number;
  txid?: string;
}
export const exchangeOrderSend = {
  fetcher: (params: IExchangeOrderSend) =>
    request(`/operation/v1/bwbexchange/exchangeOrderSend`, {
      method: 'post',
      data: params,
    }),
  key: 'exchangeOrderSend',
};
export const evmAndTonExchangeOrderSend = {
  fetcher: (params: IExchangeOrderSend) =>
    request(`/operation/v1/bwbexchange/evmAndTonExchangeOrderSend`, {
      method: 'post',
      data: params,
    }),
  key: 'evmAndTonExchangeOrderSend',
};
